import PropTypes from "prop-types";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Checkbox, InputNumber, SettingsCard, Space, Tooltip } from "top-component-library";
import { LabelWithTooltip, SaveRow, SettingControl, SettingHint } from "../styles";

const AccountWideOrderSettingsCard = ({
  minimumPaidOrderDollars,
  setMinimumPaidOrderDollars,
  allowFreeOrders,
  setAllowFreeOrders,
  allowFreeOrdersAfterPurchase,
  setAllowFreeOrdersAfterPurchase,
  onSave,
}) => (
  <SettingsCard title="Account-wide Order Settings">
    <SettingHint>Pick if you allow $0 orders or set a minimum cart amount for paid orders.</SettingHint>
    <SettingControl>
      <label htmlFor="minimum-paid-order">
        <LabelWithTooltip>
          <span>Minimum cart amount for paid orders</span>
          <Tooltip title="Rejects orders that are non-free but where the total of cart items (before tax, tip, discounts, and delivery charge) is below this amount.">
            <QuestionCircleOutlined />
          </Tooltip>
        </LabelWithTooltip>
      </label>
      <InputNumber
        id="minimum-paid-order"
        addonBefore="$"
        min={1}
        step={0.25}
        value={minimumPaidOrderDollars}
        onChange={setMinimumPaidOrderDollars}
      />
    </SettingControl>
    <Space direction="vertical">
      <Checkbox checked={allowFreeOrders} onChange={(event) => setAllowFreeOrders(event.target.checked)}>
        <LabelWithTooltip>
          <span>Allow free orders</span>
          <Tooltip title="If the menu has $0 items such as water, they can be ordered by themselves.">
            <QuestionCircleOutlined />
          </Tooltip>
        </LabelWithTooltip>
      </Checkbox>
      {!allowFreeOrders && (
        <Checkbox
          checked={allowFreeOrdersAfterPurchase}
          onChange={(event) => setAllowFreeOrdersAfterPurchase(event.target.checked)}
        >
          <LabelWithTooltip>
            <span>Allow free orders after a paid order</span>
            <Tooltip title="A guest may place up to 5 orders of $0 items, during the 4 hours after buying something. Used for extra sauce, etc.">
              <QuestionCircleOutlined />
            </Tooltip>
          </LabelWithTooltip>
        </Checkbox>
      )}
    </Space>
    <SaveRow>
      <Button type="primary" onClick={onSave}>
        Save Cart Properties
      </Button>
    </SaveRow>
  </SettingsCard>
);

AccountWideOrderSettingsCard.propTypes = {
  minimumPaidOrderDollars: PropTypes.number.isRequired,
  setMinimumPaidOrderDollars: PropTypes.func.isRequired,
  allowFreeOrders: PropTypes.bool.isRequired,
  setAllowFreeOrders: PropTypes.func.isRequired,
  allowFreeOrdersAfterPurchase: PropTypes.bool.isRequired,
  setAllowFreeOrdersAfterPurchase: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default AccountWideOrderSettingsCard;
